export const workTypeGroups = {
  WORK_TYPE_GROUP_TILL: 1,
  WORK_TYPE_GROUP_FERTILIZE: 2,
  WORK_TYPE_GROUP_SOW: 3,
  WORK_TYPE_GROUP_SPRAY: 4,
  WORK_TYPE_GROUP_HARVEST: 5,
  WORK_TYPE_GROUP_OTHER: 6,
};

export const workTypeGroupsReversed = Object.entries(workTypeGroups).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {}
);

export const wtgName = (type) => {
  if (type == workTypeGroups.WORK_TYPE_GROUP_TILL) return 'Обработка почвы';
  if (type == workTypeGroups.WORK_TYPE_GROUP_FERTILIZE)
    return 'Внесение удобрений';
  if (type == workTypeGroups.WORK_TYPE_GROUP_SOW) return 'Сев';
  if (type == workTypeGroups.WORK_TYPE_GROUP_SPRAY) return 'Защита растений';
  if (type == workTypeGroups.WORK_TYPE_GROUP_HARVEST) return 'Уборка';
  if (type == workTypeGroups.WORK_TYPE_GROUP_OTHER) return 'Прочее';
  return 'Неизвестен';
};

export const workTypeValues = {
  WORK_TYPE_FERTILIZING: 2,
  WORK_TYPE_SOWING: 3,
  WORK_TYPE_SPRAYING: 4,
  WORK_TYPE_HARVESTING: 5,
  WORK_TYPE_DISCING: 10,
  WORK_TYPE_PLOWING: 11,
  WORK_TYPE_CULTIVATION: 12,
  WORK_TYPE_SUBSOILING: 13,
  WORK_TYPE_HARROWING: 14,
  WORK_TYPE_ROLLING: 15,
  WORK_TYPE_COATING: 19,
  WORK_TYPE_IRRIGATION: 31,
  WORK_TYPE_MOVING: 32,
  WORK_TYPE_WATER_DELIVERY: 45,
  WORK_TYPE_FERTILIZER_DELIVERY: 46,
  WORK_TYPE_SEED_DELIVERY: 47,
  WORK_TYPE_CROP_REMOVAL: 48,
};

export const workStatusesValues = {
  COMPLETED: 1,
  PLANNED: 2,
  CANCELLED: 3,
};

export const workStatusName = (type) => {
  if (type == workStatusesValues.COMPLETED) return 'Выполнено';
  if (type == workStatusesValues.PLANNED) return 'План';
  if (type == workStatusesValues.CANCELLED) return 'Отменено';
  return 'Неизвестен';
};

export const workQualitiesValues = {
  BAD: -1,
  NORMAL: 0,
  GOOD: 1,
};

export const getWorkTypeGroupKeyByValue = (value) =>
  (Object.entries(workTypeGroups).find(([, val]) => val === value) || [])[0] ||
  '';

export const getWorkProcessedHectaresTitle = (type) => {
  switch (type) {
    case workTypeGroups.WORK_TYPE_GROUP_FERTILIZE:
      return 'Фактическая площадь внесения';
    case workTypeGroups.WORK_TYPE_GROUP_SOW:
      return 'Фактическая площадь сева';
    case workTypeGroups.WORK_TYPE_GROUP_TILL:
    case workTypeGroups.WORK_TYPE_GROUP_SPRAY:
    case workTypeGroups.WORK_TYPE_GROUP_OTHER:
      return 'Фактическая площадь обработки';
    case workTypeGroups.WORK_TYPE_GROUP_HARVEST:
      return 'Фактическая площадь уборки';
    default:
      return '';
  }
};

export const workTypeGroupsList = [
  workTypeGroups.WORK_TYPE_GROUP_SOW,
  workTypeGroups.WORK_TYPE_GROUP_FERTILIZE,
  workTypeGroups.WORK_TYPE_GROUP_SPRAY,
  workTypeGroups.WORK_TYPE_GROUP_HARVEST,
  workTypeGroups.WORK_TYPE_GROUP_TILL,
  workTypeGroups.WORK_TYPE_GROUP_OTHER,
].map((key) => ({ id: key, name: wtgName(key) }));

export const getVolumeUnitByWorkType = (type) => {
  switch (type) {
    case workTypeValues.WORK_TYPE_WATER_DELIVERY:
      return 'l';
    case workTypeValues.WORK_TYPE_FERTILIZER_DELIVERY:
    case workTypeValues.WORK_TYPE_SEED_DELIVERY:
    case workTypeValues.WORK_TYPE_CROP_REMOVAL:
      return 'kg';
    default:
      return '';
  }
};

export const getVolumeUnitLabelByWorkType = (type) => {
  const unit = getVolumeUnitByWorkType(type);

  if (unit === 'l') return 'л';
  if (unit === 'kg') return 'кг';
  return '';
};

export const isVolumeWorkType = (type) =>
  Boolean(getVolumeUnitByWorkType(type));
